import {createDataStore} from './createDataStore';

// Caches /data/pytorchData.json for the PyTorch tutorial pages.
// See createDataStore for the fetch-once / persist-to-localStorage behaviour.
// Bump the version below whenever pytorchData.json's content changes, to
// invalidate copies already cached in returning visitors' browsers.
export const usePytorchDataStore = createDataStore(
    '/data/pytorchData.json',
    'pytorch-data-store',
    ['slugs', 'nextPage', 'relatedPages', 'suggestedCourses'],
    1
);
